module.exports = __webpack_public_path__ + "static/img/culture-value.1259f95c.png";